import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { AlertController, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppService } from './services/app.service';
import { LangsRepository } from './services/langs.repository';
import { AuthService } from './services/auth.service';
import { SessionHeartbeatService } from './services/session-heartbeat.service';
import { CallService } from './services/call.service';
import { NotificationService } from './services/notification.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { environment } from './../environments/environment';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { MobileAccessibility } from '@ionic-native/mobile-accessibility/ngx';
import { WhatsappService } from './services/whatsapp.service';
import { LeadClientWhatsappReceivedMessage } from './model/leadClients/lead.client.whatsapp.receivedmessage';
import { MessageStatus } from './model/leadClients/lead.client.whatsapp.messagestatus';
export class AppComponent {
    constructor(platform, splashScreen, statusBar, appService, langsRepository, authService, sessionHeartbeatService, callService, notificationService, router, route, appVersion, mobileAccessibility, cdref, alertController, whatsappService) {
        this.platform = platform;
        this.splashScreen = splashScreen;
        this.statusBar = statusBar;
        this.appService = appService;
        this.langsRepository = langsRepository;
        this.authService = authService;
        this.sessionHeartbeatService = sessionHeartbeatService;
        this.callService = callService;
        this.notificationService = notificationService;
        this.router = router;
        this.route = route;
        this.appVersion = appVersion;
        this.mobileAccessibility = mobileAccessibility;
        this.cdref = cdref;
        this.alertController = alertController;
        this.whatsappService = whatsappService;
        this.langsReady = false;
        this.routeCounter = 0;
        this.showLeadsMenu = false;
        this.token = "";
        this.twoComponents = false;
        this.substatusActive = false;
        this.usersActive = false;
        this.settingsActive = false;
        this.processesActive = false;
        this.initializeApp();
        if (this.authService.authenticated) {
            this.sessionHeartbeatService.start();
        }
        this.langsRepository.ready.subscribe(r => {
            this.langsReady = r;
        }, err => console.error(err));
        this.versionNumber = environment.version;
        this.route.params.subscribe(p => {
            this.token = p["token"];
            if (!this.token) {
                if (location.hash !== "#/auth/login") {
                    var strs = location.hash.split('/');
                    this.token = strs[strs.length - 1];
                }
            }
        });
        // Listen for forced session events from backchannel.
        window.addEventListener('force-logout', (event) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const detail = (event && event.detail) ? event.detail : {};
            const eventType = (detail && typeof detail.eventType === 'string')
                ? detail.eventType.toLowerCase()
                : '';
            const requiresReauth = eventType === 'session_company_changed'
                || eventType === 'session_impersonation_started'
                || eventType === 'session_impersonation_stopped';
            console.log('Force logout event received', detail);
            if (!this.langsReady) {
                this.executeForceLogout(requiresReauth);
                return;
            }
            yield this.showForceLogoutAlert(detail, eventType, requiresReauth);
            this.executeForceLogout(requiresReauth);
        }));
    }
    showForceLogoutAlert(detail, eventType, requiresReauth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const normalizedType = eventType || 'unknown';
            const companyId = detail && detail.companyId ? detail.companyId : 'n/a';
            const sessionId = detail && detail.sessionId ? detail.sessionId : 'n/a';
            const userId = detail && detail.userId ? detail.userId : 'n/a';
            const message = requiresReauth
                ? 'Your session was updated. You need to sign in again to continue.'
                : 'Your session was revoked. You will be redirected to login.';
            const alertMessage = `${message}\n\nReason: ${normalizedType}\nUser ID: ${userId}\nCompany ID: ${companyId}\nSession ID: ${sessionId}`;
            try {
                const alert = yield this.alertController.create({
                    header: 'Session ended',
                    message: alertMessage,
                    backdropDismiss: false,
                    buttons: [{ text: 'OK', role: 'confirm' }]
                });
                yield alert.present();
                yield alert.onDidDismiss();
            }
            catch (_) {
                window.alert(alertMessage);
            }
        });
    }
    executeForceLogout(requiresReauth) {
        this.authService.logout();
        if (requiresReauth) {
            let returnRoute = '/leadClients';
            if (window.location.hash && window.location.hash.startsWith('#/')) {
                returnRoute = window.location.hash.substring(1);
            }
            if (returnRoute.indexOf('/auth/') === 0) {
                returnRoute = '/leadClients';
            }
            this.authService.prevUrl = returnRoute;
            try {
                sessionStorage.setItem('oidc-login-retry', returnRoute);
            }
            catch (_) { }
            const callbackUrl = this.authService.getOidcCallbackUrl();
            this.authService.startOidcLogin(callbackUrl);
            return;
        }
        const frontReturn = `${window.location.origin}${window.location.pathname}#/auth/login`;
        const base = (environment.baseUrlV1 && environment.baseUrlV1.replace(/\/api\/crm\/webapp\/v1\/?$/, '')) || '';
        window.location.href = `${base}/api/crm/webapp/v1/auth/logout?returnUrl=${encodeURIComponent(frontReturn)}`;
    }
    goToFixdigital() {
        if (this.isMobile) {
            const obj = new InAppBrowser().create(environment.baseFixUrl, '_system');
            obj.show();
            return;
        }
        window.open(environment.baseFixUrl);
    }
    hideLeadClient() {
        var elem = document.getElementsByClassName('lead-client-routing')[0];
        if (elem) {
            elem.classList.remove('lead-client-visible');
            elem.classList.add('lead-client-hidden');
        }
    }
    initializeApp() {
        if (this.isIeBrowser()) {
            this.appService.ieWarningPopupActive = true;
        }
        this.platform.ready().then(() => {
            if (this.isMobile) {
                this.statusBar.styleDefault();
                this.splashScreen.hide();
                this.callService.init();
                this.mobileAccessibility.usePreferredTextZoom(false);
                this.mobileAccessibility.setTextZoom(100);
            }
            // keep tab awake
            // https://learn.microsoft.com/en-us/aspnet/core/signalr/javascript-client?view=aspnetcore-7.0&tabs=visual-studio#bsleep
            let lockResolver;
            let anyTypeNavigator;
            anyTypeNavigator = navigator;
            if (anyTypeNavigator && anyTypeNavigator.locks && anyTypeNavigator.locks.request) {
                const promise = new Promise((res) => {
                    lockResolver = res;
                });
                anyTypeNavigator.locks.request('unique_lock_name', { mode: "shared" }, () => {
                    return promise;
                });
            }
            this.whatsappService.signalRConnection$.subscribe((con) => {
                if (con !== null) {
                    con.on("receiveMessage", (message, clientId, messageContentType) => {
                        if (this.router.url.indexOf(`/${clientId}/whatsapp`) === -1) {
                            const leadClient = this.appService.leadClients.find(x => x.id === clientId);
                            if (leadClient) {
                                this.notificationService.message = `${leadClient.fullName}: ${message}`;
                                leadClient.lastMessageStatus = MessageStatus.Delivered;
                            }
                            else {
                                this.notificationService.message = message;
                            }
                            this.notificationService.leadId = clientId;
                            this.notificationService.link = `/leadClients/${clientId}/whatsapp`;
                            this.notificationService.active = true;
                            setTimeout(() => {
                                this.notificationService.active = false;
                                this.cdref.detectChanges();
                            }, 5000);
                            this.cdref.detectChanges();
                        }
                        this.whatsappService.setReceivedMessage(new LeadClientWhatsappReceivedMessage(clientId, message, messageContentType));
                    });
                    con.on("receiveMessageStatus", (message, clientId) => {
                        this.whatsappService.setReceivedMessage(new LeadClientWhatsappReceivedMessage(clientId, message));
                    });
                    con.on("receiveNotification", (message, clientId) => {
                        const leadClient = this.appService.leadClients.find(x => x.id === clientId);
                        this.notificationService.message = message;
                        this.notificationService.leadId = clientId;
                        this.notificationService.link = `/leadClients/${clientId}`;
                        this.notificationService.active = true;
                        setTimeout(() => {
                            this.notificationService.active = false;
                            this.cdref.detectChanges();
                        }, 5000);
                        this.cdref.detectChanges();
                        this.whatsappService.setReceivedMessage(new LeadClientWhatsappReceivedMessage(clientId, message));
                    });
                }
            }, err => console.error(err));
        });
    }
    get networkstatusClass() { return this.appService.networkstatusClass; }
    get networkstatus() { return this.appService.networkstatus; }
    get errorActive() { return this.appService.errorActive; }
    set errorActive(v) { this.appService.errorActive = v; }
    get error() { return this.appService.error; }
    get currentLang() { return this.langsRepository.current; }
    get langs() { return this.langsRepository.langs; }
    get downloadPopupActive() { return this.appService.downloadPopupActive; }
    set downloadPopupActive(v) { this.appService.downloadPopupActive = v; }
    get androidPopupActive() { return this.appService.permissionPopupActive; }
    set androidPopupActive(v) { this.appService.permissionPopupActive = v; }
    get ieWarningPopupActive() { return this.appService.ieWarningPopupActive; }
    set ieWarningPopupActive(v) { this.appService.ieWarningPopupActive = v; }
    get versionUpdatePopupActive() { return this.appService.versionUpdatePopupActive; }
    set versionUpdatePopupActive(v) { this.appService.versionUpdatePopupActive = v; }
    get menuClass() { return this.appService.menuClass; }
    set menuClass(v) { this.appService.menuClass = v; }
    get introPopupActive() { return this.appService.introPopupActive; }
    set introPopupActive(v) { this.appService.introPopupActive = v; }
    get user() { return this.authService.user; }
    get notificationActive() { return this.notificationService.active; }
    set notificationActive(v) { this.notificationService.active = v; }
    get tooltipPopupActive() { return this.appService.tooltipPopupActive; }
    set tooltipPopupActive(v) { this.appService.tooltipPopupActive = v; }
    get textOfTooltipPopup() { return this.appService.textOfTooltipPopup; }
    set textOfTooltipPopup(v) { this.appService.textOfTooltipPopup = v; }
    get titleOfTooltipPopup() { return this.appService.titleOfTooltipPopup; }
    set titleOfTooltipPopup(v) { this.appService.titleOfTooltipPopup = v; }
    get followUpAlertNoticationActive() { return this.notificationService.followUpAlert; }
    set followUpAlertNoticationActive(v) { this.notificationService.followUpAlert = v; }
    get whatsAppNotificationActive() { return this.notificationService.whatsAppAlert; }
    set whatsAppNotificationActive(v) { this.notificationService.whatsAppAlert = v; }
    get notificationTitle() { return this.notificationService.notificationTitle; }
    get notificationLeadId() { return this.notificationService.leadId; }
    get notificationLink() { return this.notificationService.link; }
    get notificationMessage() { return this.notificationService.message; }
    get isDesctop() { return !this.platform.is("cordova"); }
    get isMobile() { return this.platform.is("ios") || this.platform.is("android"); }
    get isWhatsApp() { return location.hash.includes("#/lc/phone/"); }
    get isGmail() { return location.hash.includes("#/lc/email/"); }
    get isIOS() { return this.platform.is("ios"); }
    onActivate() {
        if (!this.platform.is("cordova")) {
            if (this.routeCounter < 3) {
                this.routeCounter++;
            }
            if (this.routeCounter === 3) {
                this.appService.initDownloadPopup();
            }
            this.showLeadsMenu = this.router.url.includes('/l/');
            if (this.showLeadsMenu) {
                this.token = this.router.url.replace('/l/', '');
            }
        }
    }
    showDownloadPopup() {
        this.appService.downloadPopupActive = true;
    }
    setCurrentLang(langSlug) {
        this.menuClass = "";
        this.langsRepository.setCurrent(langSlug);
    }
    logoutAndRedirect() {
        this.authService.logoutAndRedirect();
    }
    isIeBrowser() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        // other browser
        return false;
    }
}
